import Cal, { getCalApi } from "@calcom/embed-react"
import { useEffect } from "react"

export default function MyApp({
  emp_id,
  link,
  userName,
  userEmail,
  onBookingSuccess,
}: {
  emp_id: number
  link: string
  userName: string
  userEmail: string
  onBookingSuccess?: () => void
}) {
  const extractedCalLink = () => {
    if (!link || typeof link !== "string") {
      return null
    }
    try {
      const urlObject = new URL(link)
      const path = urlObject.pathname
      const cleanCalLink = path.startsWith("/") ? path.substring(1) : path

      return cleanCalLink
    } catch (error) {
      return null
    }
  }

  useEffect(() => {
    ;(async function () {
      const cal = await getCalApi({
        embedJsUrl: "https://calendarize.io/embed/embed.js",
      })
      cal("ui", {
        styles: { branding: { brandColor: "#000000" } },
        hideEventTypeDetails: false,
        layout: "month_view",
      })
      if (onBookingSuccess) {
        cal("on", {
          action: "bookingSuccessful",
          callback: onBookingSuccess,
        })
      }
    })()
  }, [])

  return (
    <Cal
      calLink={extractedCalLink()}
      style={{ width: "100%", height: "100%", overflow: "scroll" }}
      config={{
        layout: "month_view",
        "emp-id": String(emp_id),
        name: userName,
        "emp-name": userName,
        email: userEmail,
      }}
      calOrigin="https://calendarize.io"
      embedJsUrl="https://calendarize.io/embed/embed.js"
    />
  )
}
